var old_document_title = ''

// Array com as mensagens
const mensagens = [
  "📦Eii, volta aqui...",
  "📦Volte logo!",
  "📦Promoção!",
  "🚨Exclusivo🚨",
];

// Função para selecionar aleatoriamente uma mensagem
function selecionarMensagemAleatoria() {
  const indiceAleatorio = Math.floor(Math.random() * mensagens.length);
  return mensagens[indiceAleatorio];
}

document.addEventListener('visibilitychange', function() {
  if (document.hidden) {
    old_document_title = document.title;
    document.title = selecionarMensagemAleatoria();

  } else {

    document.title = old_document_title;
  }
});